import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import useAbsoluteWindowStore from "../../stores/absoluteWindowStore";

export const ContextMenuStyled = styled.div`
    z-index: 99999;
    position: fixed;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.1);
    min-width: 120px;
    min-height: 30px;
    padding: 5px 4px;
    flex-direction: column;
    border-radius: 4px;
    backdrop-filter: blur(20px);
    transform-origin: top left;
    transition: opacity 0.2s ease, transform 0.1s ease;
`;

export interface ContextMenuData {
    isVisible?: boolean;
    pos?: { x: number; y: number };
    children?: React.ReactNode;
}

export default function ContextMenu() {
    const contextMenuData = useAbsoluteWindowStore(
        (state) => state.windowShowing
    );
    const contextMenuPos = useAbsoluteWindowStore((state) => state.position);

    // State
    const [position, setPosition] = useState<{ x: number; y: number }>({
        x: contextMenuPos?.x || 0,
        y: contextMenuPos?.y || 0,
    });

    // Refs
    const contextMenuRef = useRef<HTMLDivElement>(null);

    // If Data Changes
    useEffect(() => {
        if (contextMenuPos) {
            SetContextPosition(contextMenuPos);
        }
    }, [contextMenuData, contextMenuPos]);

    useEffect(() => {
        const cleanup = () => {
            document.removeEventListener("mousedown", checkClickOutside);
            window.removeEventListener("resize", hideContextMenu);
        };
        if (contextMenuData?.type === "ContextMenu") {
            document.addEventListener("mousedown", checkClickOutside);
            window.addEventListener("resize", hideContextMenu);
        } else {
            cleanup();
        }
        return cleanup;
    }, [contextMenuData]);

    const hideContextMenu = () => {
        useAbsoluteWindowStore.getState().setWindowShowing(undefined);
    };

    /*________________________ Function ________________________*/
    function SetContextPosition(pos: { x: number; y: number }) {
        if (!contextMenuRef.current) return;

        const width: { x: number; y: number } = { x: pos.x, y: pos.y };

        // Ensure that context menu is always in the window.
        if (pos.x + contextMenuRef.current.offsetWidth > window.innerWidth) {
            width.x = window.innerWidth - contextMenuRef.current.offsetWidth;
        }
        if (pos.y + contextMenuRef.current.offsetHeight > window.innerHeight) {
            width.y = window.innerHeight - contextMenuRef.current.offsetHeight;
        }
        setPosition(width);
    }

    // Check if mouse clicked outside context menu.
    function checkClickOutside(e: MouseEvent) {
        const secondaryContextMenuRef = document.getElementById(
            "secondaryContextMenu"
        ) as HTMLDivElement | null;

        if (
            !contextMenuRef.current?.contains(e.target as Node) &&
            !secondaryContextMenuRef?.contains(e.target as Node)
        ) {
            hideContextMenu();
        }
    }

    return (
        <ContextMenuStyled
            ref={contextMenuRef}
            id="contextMenu"
            style={{
                transform:
                    contextMenuData?.type === "ContextMenu"
                        ? "scale(1)"
                        : "scale(.4)",
                opacity: contextMenuData?.type === "ContextMenu" ? "1" : "0",
                pointerEvents:
                    contextMenuData?.type === "ContextMenu" ? "auto" : "none",
                top: position.y,
                left: position.x,
            }}
        >
            {contextMenuData?.type === "ContextMenu" &&
                contextMenuData.children}
        </ContextMenuStyled>
    );
}

export function ContextMenuSeparator(props: { hide?: boolean }) {
    return (
        <div
            className="my-[3px] h-[1px] bg-white opacity-10"
            style={{
                display: props.hide ? "none" : "block",
            }}
        />
    );
}
